
import { WorkoutPlanContainer } from "./components/WorkoutPlanContainer";

interface WorkoutPlanRoutinesProps {
  planId?: string;
  initialPlan?: any;
  hideBackButton?: boolean;
}

export const WorkoutPlanRoutines = ({
  planId,
  initialPlan,
  hideBackButton
}: WorkoutPlanRoutinesProps) => {
  return (
    <WorkoutPlanContainer 
      planId={planId}
      initialPlan={initialPlan}
      hideBackButton={hideBackButton}
    />
  );
};
